import React from 'react';
import HeroBanner from './HeroBanner';

const PageBanner = ({
  title,
  subtitle,
  breadcrumb,
  breadcrumbs = [],
  backgroundImage,
  bgImage,
  image,
  fallback = '/images/page-banners/why-choose-us.jpg',
  fallbackImage,
  loading = false,
  ...rest
}) => {
  const finalImage = bgImage || backgroundImage || image;
  const finalFallback = fallbackImage || fallback;

  return (
    <HeroBanner
      title={title}
      subtitle={subtitle}
      breadcrumb={breadcrumb}
      breadcrumbs={breadcrumbs}
      image={finalImage}
      fallback={finalFallback}
      loading={loading}
      {...rest}
    />
  );
};

export default PageBanner;
